import { Card, Link } from '@ps/isp-web-component-library';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { TXTWCL_In_Play_information_subject_to_ELL } from './LiveDataWarning.messages.json';
import styles from './LiveDataWarning.scss';

const HELP_GAMES_SPORTS_RULES_LINK_MAP: Partial<{ [key in Sites]: ResolverTag }> = {
  [Sites.ITA]: ResolverTag.HelpGameSportsRules
};

const LiveDataWarning = () => {
  const site = useSelector(select.cms.getSiteId);

  const helpGameSportsRulesResolverTag =
    HELP_GAMES_SPORTS_RULES_LINK_MAP[site] || ResolverTag.HelpGamesSportsInPlayBettingRules;
  const helpGameSportsRulesLink = useResolver(helpGameSportsRulesResolverTag);

  return (
    <Card isPadded className={styles.card}>
      <Link variant="secondary" href={helpGameSportsRulesLink} target="_blank" rel="noreferrer">
        <Translation {...TXTWCL_In_Play_information_subject_to_ELL} />
      </Link>
    </Card>
  );
};

export default LiveDataWarning;
